// import { apiClient } from "@/services/apiServices";
// import axios from "axios";
// import { useEffect, useState } from "react";

// export const usePricingFormula = () => {
//   const [pricingData, setPricingData] = useState<any>(null);
//   const [error, setError] = useState<Error | null>(null);
//   const [loading, setLoading] = useState(false);

//   const fetchPricingFormula = async () => {
//     try {
//       setLoading(true);
//       // Use environment variable for API token
//       const response = await axios.get(
//         `https://ipinfo.io/json?token=${process.env.NEXT_PUBLIC_IPINFO_TOKEN}`
//       );
//       const userData = response.data;

//       const { data } = await apiClient.post("/pricing-formula", userData);

//       setPricingData(data?.data);
//     } catch (err) {
//       setError(
//         err instanceof Error ? err : new Error("An unknown error occurred")
//       );
//     } finally {
//       setLoading(false);
//     }
//   };
//   const convertPrice = ({
//     currency,
//     conversionRates,
//     symbol,
//     priceInINR,
//   }: {
//     currency: "USD" | "EUR" | "GBP";
//     symbol: string;
//     conversionRates: {
//       INR_TO_USD: number;
//       INR_TO_EUR: number;
//       INR_TO_GBP: number;
//     };
//     priceInINR: number;
//   }) => {
//     if (!currency) {
//       return {
//         priceWithSymbol: `₹${priceInINR}`,
//         convertedPrice: priceInINR,
//       };
//     }
//     const conversionRate = conversionRates[`INR_TO_${currency}`] || 1; // Default to 1 if rate is missing
//     const convertedPrice = Math.ceil(priceInINR * conversionRate);
//     return {
//       priceWithSymbol: `${symbol}${convertedPrice}`,
//       convertedPrice: convertedPrice,
//     };
//   };
//   useEffect(() => {
//     fetchPricingFormula();
//   }, []);

//   return {
//     pricingData,
//     error,
//     loading,
//     convertPrice,
//     refetch: fetchPricingFormula,
//   };
// };

import { apiClient } from "@/services/apiServices";
import axios from "axios";
import { useEffect, useState } from "react";

// Country-to-Currency mapping
// const countryToCurrency: { [key: string]: string } = {
//   IN: "INR", // India
//   US: "USD", // USA
//   CA: "INR", // CANADA FOR testing added inr
//   DE: "EUR", // Germany
//   FR: "EUR", // France
//   GB: "GBP", // UK
//   IT: "EUR", // Italy
//   ES: "EUR", // Spain
//   NL: "EUR", // Netherlands
//   BE: "EUR", // Belgium
//   AT: "EUR", // Austria
//   FI: "EUR", // Finland
//   IE: "EUR", // Ireland
//   PT: "EUR", // Portugal
//   BD: "EUR", // Portugal
// };

// updated
const countryToCurrency: { [key: string]: string } = {
  IN: "INR", // India → USD
  US: "USD", // USA → USD
  CA: "USD", // Canada → USD
  DE: "EUR", // Germany → EUR
  FR: "EUR", // France → EUR
  GB: "USD", // UK → USD
  IT: "EUR", // Italy → EUR
  ES: "EUR", // Spain → EUR
  NL: "EUR", // Netherlands → EUR
  BE: "EUR", // Belgium → EUR
  AT: "EUR", // Austria → EUR
  FI: "EUR", // Finland → EUR
  IE: "EUR", // Ireland → EUR
  PT: "EUR", // Portugal → EUR
  BD: "USD", // Bangladesh → USD
};

// Default currency for unsupported countries
const defaultCurrency = "INR";
type TCurrency = "INR" | "USD" | "EUR";

// Helper function to get currency symbol
function getCurrencySymbol(currency: string): string {
  const symbols: { [key: string]: string } = {
    INR: "₹",
    USD: "$",
    EUR: "€",
    GBP: "£",
  };
  return symbols[currency] || "$"; // Default to "$" if symbol is not found
}

export type TUCDT = { symbols: string; currency: TCurrency; country: string };
export const usePricingFormula = () => {
  const [ucdT, setUCDT] = useState<TUCDT | null>(null); // ucdt refers to user currency data

  const fetchPricingFormula = async () => {
    try {
      // Use environment variable for API token
      const response = await axios.get(
        `https://ipinfo.io/json?token=${process.env.NEXT_PUBLIC_IPINFO_TOKEN}`,
      );

      const userCurrency: string =
        countryToCurrency[response?.data?.country] || defaultCurrency;
      const symbol = getCurrencySymbol(userCurrency) || "$";

      const data = {
        country: response?.data?.country || "IN",
        currency: userCurrency as TCurrency,
        symbols: symbol,
      };

      localStorage.setItem("ucdt", JSON.stringify(data));
      setUCDT(data);
      // console.log("set to local storage");
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const stored = localStorage.getItem("ucdt");

    if (stored) {
      // console.log("Found from ls", stored);
      try {
        const parsed = JSON.parse(stored);
        if (parsed?.currency) {
          setUCDT(parsed);
          return;
        }
      } catch (err) {
        console.warn("Error parsing local storage data", err);
      }
    }
    // console.log("Rendered");
    fetchPricingFormula();
  }, []);

  return {
    ucdT: ucdT as TUCDT,
  };
};
